import { Outlet } from "react-router-dom";

export function FormLayout() {
  return <Outlet />;
}
